"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdFormik = require("cccisd-formik");
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross"));
var _Condition = _interopRequireDefault(require("../Condition"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var generateNewId = function generateNewId() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return array.length === 0 ? 1 : Math.max.apply(Math, _toConsumableArray(array.map(function (item) {
    return item.id;
  }))) + 1;
};
var aggregationOptions = [{
  value: 'all',
  label: 'All'
}, {
  value: 'any',
  label: 'Any'
}];
var _Level = function Level(props) {
  var path = props.path,
    values = props.values;
  var level = path ? (0, _get2["default"])(values, path) : values;
  var prefix = path ? path + '.' : '';
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].aggregation
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    wrapperClassName: "",
    name: "filter.".concat(prefix, "aggregation"),
    component: _cccisdFormik.CccisdSelect,
    options: aggregationOptions,
    style: {
      width: 'auto'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, "of the following are true")), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].conditions
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
    name: "filter.".concat(prefix, "conditions"),
    render: function render(arrayHelpers) {
      return /*#__PURE__*/_react["default"].createElement("div", null, level.conditions.length === 0 && /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-danger"
      }, "At least one condition is required"), level.conditions.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.id,
          className: "d-flex"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"]["delete"],
          onClick: function onClick() {
            return arrayHelpers.remove(index);
          }
        }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), item.conditions ? /*#__PURE__*/_react["default"].createElement(_Level, _extends({}, props, {
          path: "".concat(prefix, "conditions[").concat(index, "]")
        })) : /*#__PURE__*/_react["default"].createElement(_Condition["default"], {
          path: "".concat(prefix, "conditions[").concat(index, "]"),
          condition: item
        }));
      }), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: function onClick() {
          return arrayHelpers.push({
            id: generateNewId(level.conditions),
            column: null,
            operator: ''
          });
        }
      }, "Add condition"), ' ', /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: function onClick() {
          return arrayHelpers.push({
            id: generateNewId(level.conditions),
            aggregation: 'all',
            conditions: [{
              id: 1,
              column: null,
              operator: ''
            }]
          });
        }
      }, "Add condition set"));
    }
  })));
};
_Level.propTypes = {
  path: _propTypes["default"].string,
  values: _propTypes["default"].object
};
_Level.defaultProps = {};
var _default = exports["default"] = _Level;